import React, { useEffect, useState } from 'react';
import { SecondaryBase } from '../Commons/SecondaryBase';
import { ResetCurrentDynamic as BLResetCurrentDynamic } from '../../../utilities/BL/Zones';
import { GetRankingBL, GetAllPlayersBL, EditPlayerBL, SendScreenCommandBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL } from './../../../utilities/BL/CatchTheBall';
//import { GetRankingBL, GetAllPlayersBL, EditPlayerBL, SendScreenCommandBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL } from '../../../utilities/BL/Admin/Games/CatchTheBall';
import { ConnectWebSocketForOverlay } from '../../../utilities/BL/Zones'; // Para escuchar el estatus en vivo


const CatchTheBall = ({ getOutOfTheDynamic }) => {
    // Listas y UI
    const [ranking, setRanking] = useState([]);
    const [fullList, setFullList] = useState([]);
    const [showFullList, setShowFullList] = useState(false);
    const [isWorking, setIsWorking] = useState(false);
    const [liveStatus, setLiveStatus] = useState('ESPERANDO ACCIÓN...');
    
    // Reglas Parametrizadas
    //const [rules, setRules] = useState({ duration: 60, ballsToSpawn: 5, cardInterval: 12, trophySeconds: 10 });
    const [rules, setRules] = useState({ 
        duration: 60, 
        ballsToSpawn: 5, 
        cardInterval: 12, 
        trophySeconds: 10,
        playerScale: 3, 
        itemScale: 1.5 
    });
    
    // Manual Player Form
    const [manualPlayer, setManualPlayer] = useState({ fullName: '', nickname: '', score: 0 });
    
    // Edición
    const [editingId, setEditingId] = useState(null);
    const [editNickname, setEditNickname] = useState('');

    // CARGA DE DATOS
    const loadData = async () => {
        const resRank = await GetRankingBL();
        if (resRank.success) setRanking(resRank.data);
        
        const resAll = await GetAllPlayersBL();
        if (resAll.success) setFullList(resAll.data);
    };

    useEffect(() => {
        loadData();
        const interval = setInterval(loadData, 5000);
        
        // Escucha silenciosa del WebSocket para el "Live Status"
        ConnectWebSocketForOverlay('catchtheball', () => {}, (msg) => {
            if (msg?.data?.action === 'player_ready') setLiveStatus(`🟢 JUGANDO AHORA: ${msg.data.payload.nickname.toUpperCase()}`);
            if (msg?.data?.action === 'game_over') setLiveStatus(`🔴 PARTIDA TERMINADA (${msg.data.payload.score} Puntos)`);
            if (msg?.data?.action === 'show_ranking') setLiveStatus('🏆 MOSTRANDO RANKING');
            if (msg?.data?.action === 'show_frontpage') setLiveStatus('🎬 MOSTRANDO PORTADA');
        });

        return () => clearInterval(interval);
    }, []);

    // ==========================================================================
    // ACCIONES DE PANTALLA Y REGLAS
    // ==========================================================================
    const sendScreen = async (cmd) => { setIsWorking(true); await SendScreenCommandBL(cmd); setIsWorking(false); };
    const forceEnd = async () => { if(window.confirm('¿Terminar partida actual?')) sendScreen('force_end'); };

    const applyRules = async () => {
        setIsWorking(true);
        await SendScreenCommandBL('set_rules', rules);
        alert('Reglas aplicadas a las siguientes partidas.');
        setIsWorking(false);
    };

    // ==========================================================================
    // ACCIONES DE JUGADORES (Reset, Manual, Segunda Oportunidad)
    // ==========================================================================
    const handleResetAll = async () => {
        if (!window.confirm('🚨 ¡PELIGRO! 🚨\n\n¿Estás absolutamente seguro de que quieres BORRAR TODO el historial de jugadores?\nEsto no se puede deshacer.')) return;
        setIsWorking(true);
        await ResetAllScoresBL();
        await loadData();
        setIsWorking(false);
    };

    const handleManualSubmit = async (e) => {
        e.preventDefault();
        setIsWorking(true);
        await SubmitManualScoreBL({ ...manualPlayer, email: 'admin@manual', phoneNumber: '000', companionType: 'manual' });
        setManualPlayer({ fullName: '', nickname: '', score: 0 });
        await loadData();
        setIsWorking(false);
    };

    const giveSecondChance = async (player) => {
        if (!window.confirm(`¿Dar segunda oportunidad a ${player.nickname}? La pantalla empezará su juego al instante.`)) return;
        setIsWorking(true);
        await GiveSecondChanceBL({ 
            fullName: player.fullName, nickname: player.nickname, 
            email: player.email, phoneNumber: player.phoneNumber, companionType: player.companionType 
        });
        setIsWorking(false);
    };

    const toggleCensor = async (p) => { setIsWorking(true); await EditPlayerBL(p.id, p.nickname, !p.isCensored); loadData(); setIsWorking(false); };
    const saveEdit = async (p) => { setIsWorking(true); await EditPlayerBL(p.id, editNickname, p.isCensored); setEditingId(null); loadData(); setIsWorking(false); };

    return (
        <SecondaryBase actionToExecute={async () => { await BLResetCurrentDynamic(); getOutOfTheDynamic(); }}>
            <section className='AdmRunToGoal__Settings'>
                <p className='AdmRunToGoal__Title d-flex justify-content-between align-items-center'>
                    <span>⚽🏆 Atrapa los Balones</span>
                    <span className="badge bg-dark fs-6 shadow-sm">{liveStatus}</span>
                </p>

                <div className='row g-4'>
                    
                    {/* COLUMNA IZQUIERDA: CONTROLES */}
                    <div className="col-lg-4">
                        
                        {/* 1. Control de Pantalla */}
                        <div className="bg-light p-3 rounded border mb-3 shadow-sm">
                            <h6 className="fw-bold border-bottom pb-2">Control de Pantalla</h6>
                            <button className="btn btn-info w-100 mb-2 fw-bold" onClick={() => sendScreen('show_frontpage')} disabled={isWorking}>Mostrar Portada</button>
                            <button className="btn btn-warning w-100 mb-2 fw-bold" onClick={() => sendScreen('show_ranking')} disabled={isWorking}>Mostrar Ranking Top 10</button>
                            <button className="btn btn-danger w-100 fw-bold" onClick={forceEnd} disabled={isWorking}>¡CORTAR PARTIDA ACTUAL!</button>
                        </div>

                        {/* 2. Reglas del Juego */}
                        <div className="bg-light p-3 rounded border mb-3 shadow-sm">
                            <h6 className="fw-bold border-bottom pb-2">Reglas Parametrizables</h6>
                            <label className="small fw-bold">Segundos por partida:</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.duration} onChange={e => setRules({...rules, duration: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Spawn de Balones (Nuevos cada X):</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.ballsToSpawn} onChange={e => setRules({...rules, ballsToSpawn: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Intervalo de Tarjetas (Cada X balones):</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.cardInterval} onChange={e => setRules({...rules, cardInterval: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Frecuencia de Escudo (Segundos):</label>
                            <input type="number" className="form-control form-control-sm mb-3" value={rules.trophySeconds} onChange={e => setRules({...rules, trophySeconds: Number(e.target.value)})} />

                            <label className="small fw-bold mt-2">Tamaño del Jugador (Escala):</label>
                            <input 
                                type="number" 
                                step="0.1" 
                                className="form-control form-control-sm mb-2" 
                                value={rules.playerScale} 
                                onChange={e => setRules({...rules, playerScale: Number(e.target.value)})} 
                            />
                            
                            <label className="small fw-bold mt-2">Tamaño de Objetos (Escala):</label>
                            <input 
                                type="number" 
                                step="0.1" 
                                className="form-control form-control-sm mb-3" 
                                value={rules.itemScale} 
                                onChange={e => setRules({...rules, itemScale: Number(e.target.value)})} 
                                title="Balones, Escudos y Tarjetas"
                            />
                            
                            <button className="btn btn-dark w-100 btn-sm fw-bold" onClick={applyRules} disabled={isWorking}>Aplicar Reglas</button>
                        </div>

                        {/* 3. Agregar Manual */}
                        <form className="bg-light p-3 rounded border shadow-sm" onSubmit={handleManualSubmit}>
                            <h6 className="fw-bold border-bottom pb-2">Agregar Jugador Manual</h6>
                            <input className="form-control form-control-sm mb-2" placeholder="Nombre Real" value={manualPlayer.fullName} onChange={e => setManualPlayer({...manualPlayer, fullName: e.target.value})} required />
                            <input className="form-control form-control-sm mb-2" placeholder="Apodo (Pantalla)" value={manualPlayer.nickname} onChange={e => setManualPlayer({...manualPlayer, nickname: e.target.value})} required />
                            <input type="number" className="form-control form-control-sm mb-2" placeholder="Puntos Obtenidos" value={manualPlayer.score} onChange={e => setManualPlayer({...manualPlayer, score: Number(e.target.value)})} required />
                            <button type="submit" className="btn btn-success w-100 btn-sm fw-bold" disabled={isWorking}>Guardar Puntaje</button>
                        </form>
                    </div>

                    {/* COLUMNA DERECHA: TABLA Y JUGADORES */}
                    <div className="col-lg-8">
                        <div className="bg-white p-3 rounded border shadow-sm h-100">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                <h5 className="fw-bold mb-0">
                                    <i className="bi bi-people-fill"></i> Jugadores Registrados: <span className="text-primary">{fullList.length}</span>
                                </h5>
                                <div>
                                    <button className="btn btn-sm btn-outline-dark me-2 fw-bold" onClick={() => setShowFullList(!showFullList)}>
                                        {showFullList ? 'Ver Solo Top 10' : 'Ver Todos'}
                                    </button>
                                    <button className="btn btn-sm btn-danger fw-bold" onClick={handleResetAll} disabled={isWorking}>
                                        <i className="bi bi-trash-fill"></i> Resetear Todo
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark sticky-top">
                                        <tr>
                                            <th>Jugador</th>
                                            <th>Apodo</th>
                                            <th className="text-center">Pts</th>
                                            <th className="text-center">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(showFullList ? fullList : ranking).map((p, i) => (
                                            <tr key={p.id} className={p.isCensored ? 'table-danger' : ''}>
                                                <td><div className="fw-bold">{p.fullName}</div></td>
                                                <td>
                                                    {editingId === p.id ? (
                                                        <div className="input-group input-group-sm" style={{ width: '150px' }}>
                                                            <input type="text" className="form-control" value={editNickname} onChange={(e) => setEditNickname(e.target.value)} />
                                                            <button className="btn btn-success" onClick={() => saveEdit(p)}><i className="bi bi-check"></i></button>
                                                        </div>
                                                    ) : (
                                                        <span className={p.isCensored ? 'text-decoration-line-through' : 'fw-bold text-primary'}>{p.nickname}</span>
                                                    )}
                                                </td>
                                                <td className="text-center fw-black fs-5">{p.score}</td>
                                                <td className="text-center">
                                                    <button className="btn btn-sm btn-outline-primary me-1" title="Editar" onClick={() => { setEditingId(p.id); setEditNickname(p.nickname); }}><i className="bi bi-pencil-fill"></i></button>
                                                    <button className={`btn btn-sm me-1 ${p.isCensored ? 'btn-success' : 'btn-danger'}`} title="Censurar" onClick={() => toggleCensor(p)}>
                                                        {p.isCensored ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
                                                    </button>
                                                    {/* BOTÓN SEGUNDA OPORTUNIDAD DESDE EL ADMIN */}
                                                    <button className="btn btn-sm btn-warning fw-bold" title="Forzar Segunda Oportunidad" onClick={() => giveSecondChance(p)}>
                                                        <i className="bi bi-arrow-clockwise"></i> Jugar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </SecondaryBase>
    );
};

export { CatchTheBall };









// import React, { useEffect, useState } from 'react';
// import { SecondaryBase } from './../Commons/SecondaryBase';
// import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones';
// import { GetRankingBL, EditPlayerBL, SendScreenCommandBL, AdminControlBL } from './../../../utilities/BL/CatchTheBall';
// //import { GetRankingBL, EditPlayerBL, SendScreenCommandBL, AdminControlBL } from './../../../utilities/BL/Admin/Games/CatchTheBall';


// const CatchTheBall = ({ getOutOfTheDynamic }) => {
//     const [ranking, setRanking] = useState([]);
//     const [isWorking, setIsWorking] = useState(false);
    
//     // Edición en vivo
//     const [editingId, setEditingId] = useState(null);
//     const [editNickname, setEditNickname] = useState('');

//     // Duración de la partida controlada por el Admin
//     const [durationInput, setDurationInput] = useState(60);

//     const loadRanking = async () => {
//         const res = await GetRankingBL();
//         if (res.success) setRanking(res.data);
//     };

//     useEffect(() => {
//         loadRanking();
//         const interval = setInterval(loadRanking, 5000);
//         return () => clearInterval(interval);
//     }, []);

//     // ==========================================================================
//     // CONTROLES DE PANTALLA
//     // ==========================================================================
//     const handleShowFrontpage = async () => {
//         setIsWorking(true);
//         await SendScreenCommandBL('show_frontpage');
//         setIsWorking(false);
//     };

//     const handleShowRanking = async () => {
//         setIsWorking(true);
//         await SendScreenCommandBL('show_ranking');
//         setIsWorking(false);
//     };

//     // ==========================================================================
//     // REGLAS Y BOTÓN DE PÁNICO
//     // ==========================================================================
//     const handleSetDuration = async () => {
//         setIsWorking(true);
//         await AdminControlBL('set_duration', durationInput);
//         alert(`Tiempo actualizado a ${durationInput}s para las SIGUIENTES partidas.`);
//         setIsWorking(false);
//     };

//     const handleForceEndGame = async () => {
//         if (!window.confirm('¿Seguro que quieres terminar la partida actual AHORA MISMO?')) return;
//         setIsWorking(true);
//         await AdminControlBL('force_end');
//         setIsWorking(false);
//     };

//     // ==========================================================================
//     // MODERACIÓN
//     // ==========================================================================
//     const startEditing = (player) => {
//         setEditingId(player.id);
//         setEditNickname(player.nickname);
//     };

//     const saveEdit = async (player) => {
//         setIsWorking(true);
//         await EditPlayerBL(player.id, editNickname, player.isCensored);
//         setEditingId(null);
//         await loadRanking();
//         setIsWorking(false);
//     };

//     const toggleCensor = async (player) => {
//         setIsWorking(true);
//         await EditPlayerBL(player.id, player.nickname, !player.isCensored);
//         await loadRanking();
//         setIsWorking(false);
//     };

//     const handleReturnToDashboard = async () => {
//         await BLResetCurrentDynamic();
//         getOutOfTheDynamic();
//     };

//     return (
//         <SecondaryBase actionToExecute={handleReturnToDashboard}>
//             <section className='AdmRunToGoal__Settings'>
//                 <p className='AdmRunToGoal__Title'>⚽🏆 Atrapa los Balones</p>

//                 <div className='AdmRunToGoal__Settings__Controls'>
                    
//                     {/* 1. CONTROL DE PANTALLA GIGANTE */}
//                     <div className="mb-4 bg-light p-3 rounded border">
//                         <h6 className="fw-bold mb-3 border-bottom pb-2"><i className="bi bi-tv"></i> Control de Pantalla Gigante</h6>
//                         <div className="d-flex gap-2">
//                             <button className={`btn btn-info fw-bold w-50 shadow-sm ${isWorking ? 'disabled' : ''}`} onClick={handleShowFrontpage} disabled={isWorking}>
//                                 <i className="bi bi-image"></i> Mostrar Portada
//                             </button>
//                             <button className={`btn btn-warning fw-bold w-50 shadow-sm ${isWorking ? 'disabled' : ''}`} onClick={handleShowRanking} disabled={isWorking}>
//                                 <i className="bi bi-list-ol"></i> Mostrar Ranking Top 10
//                             </button>
//                         </div>
//                     </div>

//                     {/* 2. REGLAS Y TIEMPO (NUEVO) */}
//                     <div className="mb-4 bg-light p-3 rounded border border-danger">
//                         <h6 className="fw-bold mb-3 border-bottom pb-2 text-danger"><i className="bi bi-stopwatch"></i> Reglas del Juego (En Vivo)</h6>
                        
//                         <div className="row g-3 align-items-end mb-4">
//                             <div className="col-md-8">
//                                 <label className="form-label fw-bold small text-muted">Duración de Partida (Segundos)</label>
//                                 <input 
//                                     type="number" 
//                                     className="form-control" 
//                                     value={durationInput} 
//                                     onChange={(e) => setDurationInput(Number(e.target.value))}
//                                     min="10"
//                                     disabled={isWorking}
//                                 />
//                             </div>
//                             <div className="col-md-4">
//                                 <button className="btn btn-dark w-100 fw-bold" onClick={handleSetDuration} disabled={isWorking}>
//                                     Aplicar Tiempo
//                                 </button>
//                             </div>
//                         </div>

//                         <button className="btn btn-danger w-100 fw-bold shadow-sm" onClick={handleForceEndGame} disabled={isWorking}>
//                             <i className="bi bi-sign-stop-fill"></i> ¡TERMINAR PARTIDA EN CURSO AHORA!
//                         </button>
//                     </div>

//                     {/* 3. MODERACIÓN */}
//                     <div className="mb-4">
//                         <h5 className="fw-bold mb-3 border-bottom pb-2"><i className="bi bi-shield-lock"></i> Moderación de Jugadores (Top 10)</h5>
                        
//                         <div className="table-responsive">
//                             <table className="table table-bordered table-hover align-middle bg-white shadow-sm">
//                                 <thead className="table-dark">
//                                     <tr>
//                                         <th className="text-center">#</th>
//                                         <th>Datos del Jugador</th>
//                                         <th>Apodo Público</th>
//                                         <th className="text-center">Puntos</th>
//                                         <th className="text-center">Acciones</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {ranking.length === 0 ? (
//                                         <tr><td colSpan="5" className="text-center py-4 text-muted">Aún no hay jugadores registrados.</td></tr>
//                                     ) : (
//                                         ranking.map((player, index) => (
//                                             <tr key={player.id} className={player.isCensored ? 'table-danger opacity-75' : ''}>
//                                                 <td className="text-center fw-bold">{index + 1}</td>
//                                                 <td>
//                                                     <div className="fw-bold">{player.fullName}</div>
//                                                 </td>
//                                                 <td>
//                                                     {editingId === player.id ? (
//                                                         <div className="input-group input-group-sm">
//                                                             <input type="text" className="form-control" value={editNickname} onChange={(e) => setEditNickname(e.target.value)} />
//                                                             <button className="btn btn-success" onClick={() => saveEdit(player)}>
//                                                                 <i className="bi bi-check-lg"></i>
//                                                             </button>
//                                                         </div>
//                                                     ) : (
//                                                         <span className={player.isCensored ? 'text-decoration-line-through' : 'fw-bold text-primary'}>
//                                                             {player.nickname}
//                                                         </span>
//                                                     )}
//                                                 </td>
//                                                 <td className="text-center fw-black fs-5">{player.score}</td>
//                                                 <td className="text-center">
//                                                     {editingId !== player.id && (
//                                                         <button className="btn btn-sm btn-outline-primary me-2" onClick={() => startEditing(player)} disabled={isWorking}><i className="bi bi-pencil-fill"></i></button>
//                                                     )}
//                                                     <button className={`btn btn-sm ${player.isCensored ? 'btn-success' : 'btn-danger'}`} onClick={() => toggleCensor(player)} disabled={isWorking}>
//                                                         {player.isCensored ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                 </div>
//             </section>
//         </SecondaryBase>
//     );
// };

// export { CatchTheBall };









// import React, { useEffect, useState } from 'react'
// import { SecondaryBase } from './../Commons/SecondaryBase'
// import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'
// import { GetRankingBL, EditPlayerBL, SendScreenCommandBL } from './../../../utilities/BL/Admin/Games/CatchTheBall'


// const CatchTheBall = ({ getOutOfTheDynamic }) => {
//     const [ranking, setRanking] = useState([]);
//     const [isWorking, setIsWorking] = useState(false);
    
//     // Estados para la edición en vivo
//     const [editingId, setEditingId] = useState(null);
//     const [editNickname, setEditNickname] = useState('');

//     const loadRanking = async () => {
//         const res = await GetRankingBL();
//         if (res.success) setRanking(res.data);
//     };

//     // Cargar datos al entrar y hacer polling cada 5 segundos por si falla el WebSocket
//     useEffect(() => {
//         loadRanking();
//         const interval = setInterval(loadRanking, 5000);
//         return () => clearInterval(interval);
//     }, []);

//     // ==========================================================================
//     // CONTROLES DE PANTALLA GIGANTE
//     // ==========================================================================
//     const handleShowFrontpage = async () => {
//         setIsWorking(true);
//         await SendScreenCommandBL('show_frontpage');
//         setIsWorking(false);
//     };

//     const handleShowRanking = async () => {
//         setIsWorking(true);
//         await SendScreenCommandBL('show_ranking');
//         setIsWorking(false);
//     };

//     // ==========================================================================
//     // MODERACIÓN DE JUGADORES
//     // ==========================================================================
//     const startEditing = (player) => {
//         setEditingId(player.id);
//         setEditNickname(player.nickname);
//     };

//     const saveEdit = async (player) => {
//         setIsWorking(true);
//         await EditPlayerBL(player.id, editNickname, player.isCensored);
//         setEditingId(null);
//         await loadRanking(); // Refrescamos la tabla
//         setIsWorking(false);
//     };

//     const toggleCensor = async (player) => {
//         setIsWorking(true);
//         // Invertimos el valor de isCensored
//         await EditPlayerBL(player.id, player.nickname, !player.isCensored);
//         await loadRanking();
//         setIsWorking(false);
//     };

//     const handleReturnToDashboard = async () => {
//         await BLResetCurrentDynamic();
//         getOutOfTheDynamic();
//     };

//     return (
//         <SecondaryBase actionToExecute={handleReturnToDashboard}>
//             <section className='AdmRunToGoal__Settings'>
//                 <p className='AdmRunToGoal__Title'>⚽🏆 Atrapa los Balones</p>

//                 <div className='AdmRunToGoal__Settings__Controls'>
                    
//                     {/* CONTROLES DE PANTALLA */}
//                     <div className="mb-4 bg-light p-3 rounded border">
//                         <h6 className="fw-bold mb-3 border-bottom pb-2"><i className="bi bi-tv"></i> Control de Pantalla Gigante</h6>
//                         <div className="d-flex gap-2">
//                             <button 
//                                 className={`btn btn-info fw-bold w-50 shadow-sm ${isWorking ? 'disabled' : ''}`}
//                                 onClick={handleShowFrontpage}
//                                 disabled={isWorking}
//                             >
//                                 <i className="bi bi-image"></i> Mostrar Portada
//                             </button>
//                             <button 
//                                 className={`btn btn-warning fw-bold w-50 shadow-sm ${isWorking ? 'disabled' : ''}`}
//                                 onClick={handleShowRanking}
//                                 disabled={isWorking}
//                             >
//                                 <i className="bi bi-list-ol"></i> Mostrar Ranking Top 10
//                             </button>
//                         </div>
//                     </div>

//                     {/* MODERACIÓN (RANKING) */}
//                     <div className="mb-4">
//                         <h5 className="fw-bold mb-3 border-bottom pb-2"><i className="bi bi-shield-lock"></i> Moderación de Jugadores (Top 10)</h5>
                        
//                         <div className="table-responsive">
//                             <table className="table table-bordered table-hover align-middle bg-white shadow-sm">
//                                 <thead className="table-dark">
//                                     <tr>
//                                         <th className="text-center">#</th>
//                                         <th>Datos del Jugador</th>
//                                         <th>Apodo Público</th>
//                                         <th className="text-center">Puntos</th>
//                                         <th className="text-center">Acciones</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {ranking.length === 0 ? (
//                                         <tr>
//                                             <td colSpan="5" className="text-center py-4 text-muted">Aún no hay jugadores registrados.</td>
//                                         </tr>
//                                     ) : (
//                                         ranking.map((player, index) => (
//                                             <tr key={player.id} className={player.isCensored ? 'table-danger opacity-75' : ''}>
//                                                 <td className="text-center fw-bold">{index + 1}</td>
//                                                 <td>
//                                                     <div className="fw-bold">{player.fullName}</div>
//                                                     <div className="small text-muted">{player.phoneNumber} | {player.email}</div>
//                                                 </td>
//                                                 <td>
//                                                     {editingId === player.id ? (
//                                                         <div className="input-group input-group-sm">
//                                                             <input 
//                                                                 type="text" 
//                                                                 className="form-control" 
//                                                                 value={editNickname} 
//                                                                 onChange={(e) => setEditNickname(e.target.value)} 
//                                                             />
//                                                             <button className="btn btn-success" onClick={() => saveEdit(player)}>
//                                                                 <i className="bi bi-check-lg"></i>
//                                                             </button>
//                                                         </div>
//                                                     ) : (
//                                                         <span className={player.isCensored ? 'text-decoration-line-through' : 'fw-bold text-primary'}>
//                                                             {player.nickname}
//                                                         </span>
//                                                     )}
//                                                 </td>
//                                                 <td className="text-center fw-black fs-5">{player.score}</td>
//                                                 <td className="text-center">
//                                                     {/* Botón Editar Apodo */}
//                                                     {editingId !== player.id && (
//                                                         <button 
//                                                             className="btn btn-sm btn-outline-primary me-2" 
//                                                             onClick={() => startEditing(player)}
//                                                             title="Editar Apodo"
//                                                             disabled={isWorking}
//                                                         >
//                                                             <i className="bi bi-pencil-fill"></i>
//                                                         </button>
//                                                     )}
                                                    
//                                                     {/* Botón Censurar / Restaurar */}
//                                                     <button 
//                                                         className={`btn btn-sm ${player.isCensored ? 'btn-success' : 'btn-danger'}`} 
//                                                         onClick={() => toggleCensor(player)}
//                                                         title={player.isCensored ? "Restaurar al Ranking" : "Ocultar del Ranking"}
//                                                         disabled={isWorking}
//                                                     >
//                                                         {player.isCensored ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                         <p className="small text-muted mt-2">
//                             <i className="bi bi-info-circle"></i> Los jugadores censurados no aparecerán en la pantalla gigante, pero se conservan en la base de datos.
//                         </p>
//                     </div>

//                 </div>
//             </section>
//         </SecondaryBase>
//     );
// };

// export { CatchTheBall };